import React from 'react';

interface HeaderProps {
  transparent?: boolean;
}

const Header: React.FC<HeaderProps> = ({ transparent = false }) => {
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const headerClasses = `
    fixed w-full z-50 transition-all duration-300
    ${isScrolled || !transparent ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}
  `;

  const navLinkClasses = `
    relative px-4 py-2 text-dark hover:text-primary transition-colors duration-300
    after:content-[''] after:absolute after:w-0 after:h-0.5 after:bg-gradient-to-r after:from-primary after:to-secondary
    after:left-0 after:bottom-0 after:transition-all after:duration-300
    hover:after:w-full
  `;

  const mobileMenuClasses = `
    fixed top-0 right-0 h-screen w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50
    ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
  `;

  return (
    <header className={headerClasses}>
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Logo */}
        <h1 className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          La Cuisine Digitale
        </h1>

        {/* Desktop Navigation */}
        <nav className="hidden md:block">
          <ul className="flex space-x-2">
            <li><a href="/" className={navLinkClasses}>Accueil</a></li>
            <li><a href="/recipes" className={navLinkClasses}>Mes Recettes</a></li>
            <li><a href="/add-recipe" className={navLinkClasses}>Ajouter une Recette</a></li>
            <li><a href="/world-recipes" className={navLinkClasses}>Recettes du Monde</a></li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-dark focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Mobile Menu */}
        <div className={mobileMenuClasses}>
          <div className="p-4 flex justify-end">
            <button 
              className="text-dark focus:outline-none"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <nav className="p-4">
            <ul className="space-y-4">
              <li><a href="/" className="block py-2 text-dark hover:text-primary">Accueil</a></li>
              <li><a href="/recipes" className="block py-2 text-dark hover:text-primary">Mes Recettes</a></li>
              <li><a href="/add-recipe" className="block py-2 text-dark hover:text-primary">Ajouter une Recette</a></li>
              <li><a href="/world-recipes" className="block py-2 text-dark hover:text-primary">Recettes du Monde</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
